import React, { useState } from "react";
import { Box, Button, Menu, MenuItem, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import classes from "./SortPostsBy.module.scss";

type SortOption = "Top" | "Recent";

interface SortByDropdownProps {
    onSortChange: (option: SortOption) => void;
}

const SortByDropdown: React.FC<SortByDropdownProps> = ({ onSortChange }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedOption, setSelectedOption] = useState<SortOption>("Recent");
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOptionSelect = (option: SortOption) => {
        setSelectedOption(option);
        onSortChange(option);
        handleClose();
    };

    return (
        <Box className={classes.buttonContainer}>
            {/* <Button
                id="sort-button"
                aria-controls={open ? "sort-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : "false"}
                onClick={handleClick}
                className={classes.button}
                disableRipple
            >
                <Box display="flex" alignItems="center">
                    <Typography variant="subtitle1" color="var(--text-colour)" sx={{ mr: 0.5 }}>
                        Sort by:
                    </Typography>
                    <Typography variant="subtitle1" sx={{ ml: 0.5 }}>
                        {selectedOption}
                    </Typography>
                    <KeyboardArrowDownIcon sx={{ color: "var(--text-color)" }} />
                </Box>
            </Button> */}

            <Menu
                id="sort-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    "aria-labelledby": "sort-button",
                }}
            >
                <MenuItem
                    onClick={() => handleOptionSelect("Recent")}
                    selected={selectedOption === "Recent"}
                >
                    Recent
                </MenuItem>
                <MenuItem
                    onClick={() => handleOptionSelect("Top")}
                    selected={selectedOption === "Top"}
                >
                    Top
                </MenuItem>
            </Menu>
        </Box>
    );
};

export default SortByDropdown;
